import { render, staticRenderFns } from "./addContact.vue?vue&type=template&id=f11168fe&"
import script from "./addContact.vue?vue&type=script&lang=js&"
export * from "./addContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports